import { DeviceMode, type NodeV2, type NodeV2Style } from '@vedalib/editor'
import { FileUsageTypeEnum } from '@vedalib/editor/lib/files'
import { rtValueToText } from '@vedalib/rich-text'

import { ELEMENTS_CONFIG } from 'components/Editor/EditorElements/elements.config'
import { mergeNodeStyle } from 'services/Store/Project/selectors'
import type { Block } from 'services/Store/Project/types'
import { t } from 'services/Translation'
import { getFileByUsage } from 'utils/files'

export const getNodeLabel = (
  block?: Block | null,
  node?: NodeV2 | null,
  styles?: NodeV2Style | null,
): string => {
  if (node?.label) {
    return node.label
  }
  if (styles?.display === 'flex') {
    return t(`editor.flex`)
  }
  if (styles?.display === 'grid') {
    return t(`editor.grid`)
  }
  if (styles?.display === 'absolute') {
    return t(`editor.absolute`)
  }

  if (block && node?.elementId) {
    const element = block.elements[node.elementId]
    if (element?.type === 'richText') {
      const text = rtValueToText(element.value)
      return text || ELEMENTS_CONFIG[element?.type]?.label || t('common.empty')
    }
    if (element?.type === 'image') {
      if (element.value?.image?.source === 'url') {
        return (
          element.value?.image?.url || ELEMENTS_CONFIG[element?.type]?.label || t('common.empty')
        )
      }

      if (element.value?.image?.source === 'file') {
        const file = getFileByUsage(element.value?.image, FileUsageTypeEnum.image)
        return file?.name || ELEMENTS_CONFIG[element?.type]?.label || t('common.empty')
      }
    }
    return ELEMENTS_CONFIG[element?.type]?.label || t('common.empty')
  }

  return t('common.empty')
}

export const getNodeTechLabel = (
  device = DeviceMode.desktop,
  block?: Block,
  node?: NodeV2,
): string => {
  if (block && node) {
    if (node.elementId) {
      const element = block.elements[node.elementId]
      return ELEMENTS_CONFIG[element?.type]?.label || t('common.empty')
    }
    const styles = mergeNodeStyle(node.style, device)
    if (styles?.display === 'flex') {
      return t(`editor.flex`)
    }
    if (styles?.display === 'grid') {
      return t(`editor.grid`)
    }
    if (styles?.display === 'absolute') {
      return t(`editor.absolute`)
    }
  }
  return t('common.empty')
}
